import { DOCUMENT, inject, isDevMode, PLATFORM_ID, RendererFactory2 } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { SITE_CONFIG_DATA } from './site-config.model';

export const ORGANIZATION_SCHEMA_ATTR = 'organization';

export function organizationJsonLdInitializerFn(): void {
    const platformId = inject(PLATFORM_ID);
    if (!isPlatformServer(platformId)) {
        return;
    }
    const config = inject(SITE_CONFIG_DATA, { optional: true });
    if (!config?.organization || typeof config.organization !== 'object') {
        if (isDevMode()) {
            const reason = config?.parseError
                ? `parse error: ${config.parseError}`
                : 'no organization data in SITE_CONFIG_DATA';
            console.info(`[organization-jsonld] skipping injection (${reason})`);
        }
        return;
    }
    const document = inject(DOCUMENT);
    const renderer = inject(RendererFactory2).createRenderer(null, null);
    const el = renderer.createElement('script') as HTMLScriptElement;
    renderer.setAttribute(el, 'type', 'application/ld+json');
    renderer.setAttribute(el, 'data-schema', ORGANIZATION_SCHEMA_ATTR);
    el.textContent = JSON.stringify(config.organization);
    renderer.appendChild(document.head, el);
}
